/**
 * Describes the site monitoring column types
 * This is stored along column definitions so that when we get a dto returned by the backend,
 * we know where to get the data from
 */
export enum SiteMonitoringColumnType {
  SiteProperty = 'SP',
  MonitoredValue = 'MV',
}
